module.exports = __webpack_public_path__ + "static/media/lah-logo.b25cc596.png";